import { render, staticRenderFns } from "./select-department-tree.vue?vue&type=template&id=1e2f7fc2"
import script from "./select-department-tree.vue?vue&type=script&lang=js"
export * from "./select-department-tree.vue?vue&type=script&lang=js"
import style0 from "./select-department-tree.vue?vue&type=style&index=0&id=1e2f7fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports